/* =====================================================================
   Cart Enhance
   - シリーズタブ UI (Lorcana など増えても自動対応)
   - カード種別グループのアコーディオン化 (デフォルト全展開)
   - Shopify Recommendations API で「ついでに」枠を生成
     intent=complementary を最優先・同BOX/お気に入りで補強
   - PC sticky aside / SP sticky CTA フッター
   ===================================================================== */
(function () {
  'use strict';

  if (!/\/cart(\/|\?|$)/.test(location.pathname)) return; /* カートページ専用 */

  /* ===== タブ <-> radio 同期 + シリーズフィルタ適用 ===================== */
  function applyCategoryFilter(cat) {
    const items = document.querySelectorAll('.custom_cart__item');
    items.forEach(el => {
      const pt = (el.dataset.customProductType || el.dataset.productType || '').trim();
      let visible = true;
      if (cat === 'pokemon')      visible = pt.includes('ポケモン');
      else if (cat === 'onepiece') visible = pt.includes('ワンピース');
      else if (cat === 'lorcana')  visible = pt.includes('ロルカナ') || /lorcana/i.test(pt);
      /* リスト表示の `display:grid !important` に勝つためクラス制御 */
      el.classList.toggle('cart-item--filtered-out', !visible);
    });
    /* 空グループは非表示にする */
    document.querySelectorAll('.cart_results').forEach(group => {
      const visibles = Array.from(group.querySelectorAll('.custom_cart__item')).filter(el => !el.classList.contains('cart-item--filtered-out'));
      group.classList.toggle('cart-results--empty', visibles.length === 0);
    });
  }
  function setupTabs() {
    const tabs = document.querySelectorAll('.cart-tab');
    if (!tabs.length) return;
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const cat = tab.dataset.category;
        tabs.forEach(t => {
          const on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        const radio = document.querySelector('input[name="category"][value="' + cat + '"]');
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        /* シリーズフィルタを即時反映 (旧スクリプトの結果に依存しない) */
        applyCategoryFilter(cat);
      });
    });
  }

  /* ===== タブの件数集計 + 該当シリーズが居なければタブ非表示 ============= */
  function refreshTabCounts() {
    const items = document.querySelectorAll('.custom_cart__item');
    const counts = { all: items.length, pokemon: 0, onepiece: 0, lorcana: 0 };
    items.forEach(el => {
      const pt = (el.dataset.customProductType || '');
      if (pt.includes('ポケモン')) counts.pokemon++;
      if (pt.includes('ワンピース')) counts.onepiece++;
      if (pt.includes('ロルカナ') || /lorcana/i.test(pt)) counts.lorcana++;
    });
    Object.entries(counts).forEach(([key, n]) => {
      const el = document.querySelector('[data-tab-count="' + key + '"]');
      if (el) el.textContent = n;
      const tab = document.querySelector('.cart-tab[data-category="' + key + '"]');
      if (!tab) return;
      if (key === 'all') return; /* all は常に表示 */
      if (n > 0) tab.removeAttribute('hidden');
      else tab.setAttribute('hidden', '');
    });
  }

  /* ===== カード種別グループをアコーディオン化 (デフォルト全展開) ======== */
  function setupAccordions() {
    document.querySelectorAll('.cart_results').forEach(group => {
      if (group.dataset.acc === '1') return;
      group.dataset.acc = '1';

      const header = group.querySelector(':scope > p[class*="custom-cart-item-"]');
      const body = group.querySelector(':scope > .custom_cart__items');
      if (!header || !body) return;

      /* ラッパ化 */
      header.classList.add('cart-acc__header');
      body.classList.add('cart-acc__body');
      header.setAttribute('role', 'button');
      header.setAttribute('aria-expanded', 'true');
      header.setAttribute('tabindex', '0');

      /* chevron 追加 */
      const chev = document.createElement('span');
      chev.className = 'cart-acc__chev';
      chev.setAttribute('aria-hidden', 'true');
      chev.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';
      header.appendChild(chev);

      const toggle = () => {
        const expanded = header.getAttribute('aria-expanded') === 'true';
        const next = !expanded;
        header.setAttribute('aria-expanded', String(next));
        /* CSS の !important に勝つためクラス制御 */
        group.classList.toggle('cart-acc--collapsed', !next);
      };
      header.addEventListener('click', toggle);
      header.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });
  }

  /* ===== 空グループは丸ごと非表示 (件数 0) ============================= */
  function hideEmptyGroups() {
    document.querySelectorAll('.cart_results').forEach(group => {
      const count = group.querySelectorAll('.custom_cart__item').length;
      group.style.display = count > 0 ? '' : 'none';
    });
  }

  /* ===== Algolia 同じ収録BOX で「ついでに」推薦 ====================== */
  const _algoliaRecoCache = new Map();
  async function fetchSameBox(boxName, productType, excludeHandles) {
    if (!boxName) return [];
    const key = boxName + '|' + (productType || '');
    if (_algoliaRecoCache.has(key)) return _algoliaRecoCache.get(key);
    try {
      /* facetFilters は値先頭の `-` を否定演算子として解釈するため filters 句 + 二重引用符に統一 */
      const escapedBox = String(boxName).replace(/"/g, '\\"');
      const params = new URLSearchParams({
        query: '',
        /* メーカー=店舗(店舗専売品)は除外 */
        filters: 'meta.custom.custom_box_name_view_v2:"' + escapedBox + '" AND NOT meta.custom.manufacturer:"店舗"',
        hitsPerPage: '20',
        attributesToRetrieve: 'title,handle,product_image,image,price,inventory_quantity',
        /* 価格0円のvariantは「ついでに」関連商品から除外 */
        numericFilters: '["price > 0"]',
      }).toString();
      const res = await fetch('https://AH80R61Z2R-dsn.algolia.net/1/indexes/shopify_algoliaproducts/query', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Algolia-API-Key': '95a0bd9d5238bca651821399645560a7',
          'X-Algolia-Application-Id': 'AH80R61Z2R',
        },
        body: JSON.stringify({ params }),
      });
      if (!res.ok) return [];
      const data = await res.json();
      _algoliaRecoCache.set(key, data.hits || []);
      return data.hits || [];
    } catch (_) { return []; }
  }

  function escapeHtml(s) { return String(s ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }
  function fmtPrice(c) { if (c == null) return ''; return '¥' + (c).toLocaleString('ja-JP'); }

  /* ===== Algolia から handle 群の box_name を一括取得 (multipleQueries) ==
     1HTTPリクエストで全カート商品の box_name を引く。Liquid 出力に依存しない */
  async function fetchBoxNamesByHandles(handles) {
    if (!handles.length) return new Map();
    try {
      const requests = handles.map(h => ({
        indexName: 'shopify_algoliaproducts',
        params: new URLSearchParams({
          query: h,
          restrictSearchableAttributes: 'handle',
          typoTolerance: 'false',
          hitsPerPage: '5',
          attributesToRetrieve: 'handle,meta.custom.custom_box_name_view_v2',
        }).toString(),
      }));
      const res = await fetch('https://AH80R61Z2R-dsn.algolia.net/1/indexes/*/queries', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Algolia-API-Key': '95a0bd9d5238bca651821399645560a7',
          'X-Algolia-Application-Id': 'AH80R61Z2R',
        },
        body: JSON.stringify({ requests }),
      });
      if (!res.ok) return new Map();
      const data = await res.json();
      const out = new Map();
      (data.results || []).forEach((r, i) => {
        const target = handles[i];
        const hit = (r.hits || []).find(h => h.handle === target);
        if (!hit) return;
        const v = hit.meta && hit.meta.custom && hit.meta.custom.custom_box_name_view_v2;
        if (!v) return;
        const box = Array.isArray(v) ? v[0] : String(v);
        if (box) out.set(target, String(box).trim());
      });
      return out;
    } catch (_) { return new Map(); }
  }

  async function renderRecommendations() {
    const wrap = document.querySelector('[data-cart-recos]');
    const list = document.querySelector('[data-cart-recos-list]');
    const empty = document.querySelector('[data-cart-recos-empty]');
    if (!wrap || !list) return;

    const itemEls = Array.from(document.querySelectorAll('.custom_cart__item[data-product-handle]'));
    const cartHandles = new Set(itemEls.map(el => el.dataset.productHandle).filter(Boolean));

    /* Algolia から handle->box_name を 1リクエストで取得 */
    const handleList = Array.from(cartHandles);
    const boxMap = await fetchBoxNamesByHandles(handleList);

    /* カート上から順に同BOXを集める (重複は除外) */
    const boxRequests = [];
    const seenBoxes = new Set();
    handleList.forEach(h => {
      const box = boxMap.get(h);
      if (!box || seenBoxes.has(box)) return;
      seenBoxes.add(box);
      boxRequests.push({ box });
    });

    if (!boxRequests.length) {
      console.warn('[cart-recos] 同BOXが取得できませんでした。カート商品にBOX名メタフィールド未設定の可能性。');
      wrap.setAttribute('hidden', '');
      return;
    }

    const arrays = await Promise.all(boxRequests.map(b => fetchSameBox(b.box, null, cartHandles)));
    const merged = [];
    const seen = new Set();
    arrays.forEach(arr => arr.forEach(h => {
      if (!h.handle || cartHandles.has(h.handle) || seen.has(h.handle)) return;
      seen.add(h.handle);
      merged.push(h);
    }));

    if (merged.length === 0) {
      wrap.setAttribute('hidden', '');
      return;
    }

    wrap.removeAttribute('hidden');
    if (empty) empty.setAttribute('hidden', '');
    const top = merged.slice(0, 8);
    list.innerHTML = top.map(h => {
      let img = h.product_image || h.image || '';
      if (img && img.startsWith('//')) img = 'https:' + img;
      return (
        '<a class="cart-recos__card" href="/products/' + h.handle + '" data-handle="' + h.handle + '" data-cart-recos-card>' +
          '<img class="cart-recos__img" src="' + (img || (window.QCM_NOIMAGE_SRC || '')) + '" alt="' + escapeHtml(h.title) + '" loading="lazy">' +
          '<span class="cart-recos__name">' + escapeHtml(h.title) + '</span>' +
          '<span class="cart-recos__price">' + fmtPrice(h.price) + '</span>' +
        '</a>'
      );
    }).join('');
    const title = wrap.querySelector('.cart-recos__title');
    if (title) title.textContent = 'ついでにいかがですか？';
  }

  /* ===== 最近見た商品 ==================================================== */
  async function renderRecentlyViewed() {
    const wrap = document.querySelector('[data-cart-viewed]');
    const list = document.querySelector('[data-cart-viewed-list]');
    if (!wrap || !list) return;
    let arr = [];
    try { arr = JSON.parse(localStorage.getItem('recently_viewed') || '[]'); } catch(_){}
    /* カート内商品は除外 */
    const cartHandles = new Set(Array.from(document.querySelectorAll('.custom_cart__item[data-product-handle]')).map(el => el.dataset.productHandle));
    arr = arr.filter(h => !cartHandles.has(h)).slice(0, 8);
    if (!arr.length) { wrap.setAttribute('hidden', ''); return; }
    const products = await Promise.all(arr.map(h =>
      fetch('/products/' + h + '.js', { credentials: 'same-origin' })
        .then(r => r.ok ? r.json() : null).catch(() => null)
    ));
    const items = products.map((p, i) => ({ p, h: arr[i] })).filter(x => x.p);
    if (!items.length) { wrap.setAttribute('hidden', ''); return; }
    wrap.removeAttribute('hidden');
    list.innerHTML = items.map(({p, h}) => {
      let img = p.featured_image || (p.images && p.images[0]) || '';
      if (img && img.startsWith('//')) img = 'https:' + img;
      const min = p.variants?.length ? Math.min.apply(null, p.variants.map(v => v.price)) : 0;
      return (
        '<a class="cart-recos__card" href="/products/' + h + '" data-handle="' + h + '" data-cart-recos-card>' +
          '<img class="cart-recos__img" src="' + (img || (window.QCM_NOIMAGE_SRC || '')) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' +
          '<span class="cart-recos__name">' + escapeHtml(p.title) + '</span>' +
          '<span class="cart-recos__price">' + fmtPrice(min/100) + '</span>' +
        '</a>'
      );
    }).join('');
  }

  /* ===== recos / 最近見た商品 クリック → モーダル起動 ================== */
  function setupRecosModalTrigger() {
    document.addEventListener('click', (e) => {
      const card = e.target.closest('[data-cart-recos-card]');
      if (!card) return;
      const handle = card.dataset.handle;
      if (!handle) return;
      /* 中クリック・修飾キー時は通常リンク挙動を尊重 */
      if (e.button === 1 || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      if (typeof window.QCM_openForHandle === 'function') {
        window.QCM_openForHandle(handle);
      } else {
        location.href = '/products/' + handle;
      }
    }, true);
  }

  /* ===== SP sticky footer に subtotal を表示 ============================ */
  function setupStickyFooter() {
    if (window.matchMedia('(min-width: 768px)').matches) return;
    const aside = document.querySelector('.custom_cart__aside');
    if (!aside) return;
    const subtotalEl = aside.querySelector('[data-cart-total], .cart__total, .cart__subtotal, [data-subtotal]');
    if (!subtotalEl) return;
    /* チェックアウトボタン群の上に subtotal を複製 */
    const btnRow = aside.querySelector('.cart__buttons[data-cart-checkout-buttons]');
    if (!btnRow) return;
    if (btnRow.querySelector('.sp-cart-summary')) return;
    const summary = document.createElement('div');
    summary.className = 'sp-cart-summary';
    summary.innerHTML = '<span class="sp-cart-summary__label">小計</span><span class="sp-cart-summary__value" data-sp-subtotal></span>';
    btnRow.prepend(summary);
    /* 小計値を反映 */
    const valueEl = summary.querySelector('[data-sp-subtotal]');
    function syncSubtotal() {
      const txt = (subtotalEl.textContent || '').trim();
      if (valueEl && txt) valueEl.textContent = txt;
    }
    syncSubtotal();
    new MutationObserver(syncSubtotal).observe(subtotalEl, { childList: true, characterData: true, subtree: true });
  }

  /* ===== 数量 +/- / 削除を /cart/change.js で確実に反映 ================ */
  function setupQuantitySync() {
    let busy = false;
    function preserveActiveTab() {
      /* 現在アクティブなタブを URL ?series= に書き戻してリロード後も同じタブを表示 */
      const active = document.querySelector('.cart-tab.is-active');
      const cat = active?.dataset.category || 'all';
      try {
        const u = new URL(window.location.href);
        if (cat === 'all') u.searchParams.delete('series');
        else u.searchParams.set('series', cat);
        window.location.replace(u.pathname + (u.search || '') + u.hash);
      } catch (_) { location.reload(); }
    }
    async function changeLine(key, qty) {
      if (busy) return; busy = true;
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: key, quantity: qty }),
        });
        if (!res.ok) { busy = false; return; }
        preserveActiveTab();
      } catch (_) { busy = false; }
    }
    document.addEventListener('click', (e) => {
      const item = e.target.closest('.custom_cart__item');
      if (!item) return;
      const key = item.dataset.item;
      if (!key) return;

      const plus = e.target.closest('[data-quantity-plus]');
      const minus = e.target.closest('[data-quantity-minus]');
      const removeBtn = e.target.closest('[data-item-remove]');
      if (!plus && !minus && !removeBtn) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      if (removeBtn) { changeLine(key, 0); return; }
      const input = item.querySelector('[data-quantity-field]');
      const cur = parseInt(input?.value || '0', 10) || 0;
      const next = plus ? cur + 1 : Math.max(0, cur - 1);
      if (next === cur) return;
      changeLine(key, next);
    }, true);
  }

  /* ===== 表示切替 (リスト ⇔ グリッド) ================================ */
  function setupViewToggle() {
    const main = document.querySelector('.cart__main');
    const btns = document.querySelectorAll('.cart-view-btn');
    if (!main || !btns.length) return;
    const KEY = 'cart_view_mode';
    let saved = 'list';
    try { saved = localStorage.getItem(KEY) || 'list'; } catch (_) {}
    function apply(view) {
      main.dataset.cartView = view;
      btns.forEach(b => {
        const on = b.dataset.view === view;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      try { localStorage.setItem(KEY, view); } catch (_) {}
    }
    apply(saved);
    btns.forEach(b => b.addEventListener('click', () => apply(b.dataset.view)));
  }

  /* ===== URL ?series= から初期タブを決定 ================================ */
  function activateInitialTab() {
    let cat = 'all';
    try {
      const u = new URL(window.location.href);
      const s = (u.searchParams.get('series') || '').toLowerCase();
      if (['pokemon', 'onepiece', 'lorcana'].includes(s)) cat = s;
    } catch (_) {}
    const tab = document.querySelector('.cart-tab[data-category="' + cat + '"]');
    if (!tab || tab.hasAttribute('hidden')) return;
    document.querySelectorAll('.cart-tab').forEach(t => {
      const on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    const radio = document.querySelector('input[name="category"][value="' + cat + '"]');
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    applyCategoryFilter(cat);
  }

  /* ===== カート内の「在庫>0+価格0円」variantを自動削除+警告 ============= */
  async function purgeZeroPriceItems() {
    try {
      const r = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!r.ok) return;
      const cart = await r.json();
      /* Shopify /cart.js の price は cent。価格0円なら 0 */
      const bad = (cart.items || []).filter(it => Number(it.price || 0) <= 0);
      if (!bad.length) return;
      for (const it of bad) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: it.key, quantity: 0 }),
        });
      }
      const wrap = document.querySelector('.cart__main, .cart__content') || document.body;
      const banner = document.createElement('div');
      banner.style.cssText = 'background:#fef3c7;color:#92400e;padding:10px 14px;border-radius:8px;margin:0 0 12px;font-size:13px;font-weight:500;';
      banner.textContent = '販売価格が未設定の商品が含まれていたためカートから除外しました。';
      wrap.prepend(banner);
      setTimeout(() => location.reload(), 1500);
    } catch (_) {}
  }

  /* ===== init ============================================================ */
  function init() {
    setupTabs();
    setupViewToggle();
    refreshTabCounts();
    activateInitialTab();
    setupAccordions();
    hideEmptyGroups();
    renderRecommendations();
    renderRecentlyViewed();
    setupStickyFooter();
    setupQuantitySync();
    setupRecosModalTrigger();
    purgeZeroPriceItems();
    document.addEventListener('wishlist:changed', () => renderRecommendations());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
